import { action } from 'satcheljs/lib/legacy';
import { getUserConfiguration } from 'owa-session-store';
import { updateGetStartedPontConfig } from '../utils/updateGetStartedPontConfig';
import { logUsage } from 'owa-analytics';
import PontType from 'owa-service/lib/contract/PontType';

export default action('closeGetStartedInListView')(function closeGetStartedInListView() {
    logUsage('GetStartedInListViewClosed', {}, { isCore: true });
    getUserConfiguration().UserOptions.NewEnabledPonts &= ~PontType.ShowGetStartedPane;
    updateGetStartedPontConfig(getUserConfiguration().UserOptions.NewEnabledPonts);
});
